var e={exports:{}};export{e as __module};
//# sourceMappingURL=ipaddr.mjs.map
